import { useQuery } from '@tanstack/react-query';
import { fetchCaseVerifications } from '../api/verifications';

export const useCaseVerifications = (caseNumber) => {
  return useQuery({
    queryKey: ['case-verifications', caseNumber],
    queryFn: () => fetchCaseVerifications(caseNumber),
    enabled: !!caseNumber,
    staleTime: 60_000,
  });
};
